export default "__VITE_ASSET__3f1e6f5e__"